import { WebPushNotificationsService } from './../providers/web-push/web-push-notifications.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Camera } from '@ionic-native/camera';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Geolocation } from '@ionic-native/geolocation';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { Items } from '../mocks/providers/items';
import { Settings } from '../providers/providers';
import { User } from '../providers/providers';
import { Api } from '../providers/providers';
import { MyApp } from './app.component';
import { MyEventsProvider } from '../providers/my-events/my-events';
import { MyEventsPage } from '../pages/my-events/my-events';
import { EventDetailsPage } from '../pages/event-details/event-details';
import { ComponentsModule } from '../components/components.module';
import { MessengerProvider } from '../providers/messenger/messenger';
import { MatchmakingProvider } from '../providers/matchmaking/matchmaking';
import { CurrentEventProvider } from '../providers/current-event/current-event';
import { ProfileProvider } from '../providers/profile/profile';
import { GlobalNotificationsProvider } from '../providers/global-notifications/global-notifications';
import { ProfileSettingsProvider } from '../providers/profile-settings/profile-settings';
import { ContactRequestProvider } from '../providers/contact-request/contact-request';
import { EventWallProvider } from '../providers/event-wall/event-wall';
import { DatePipe } from '@angular/common';
import { CountryListProvider } from '../providers/country-list/country-list';
import { LinkyModule } from 'angular-linky';
import { InlineSVGModule } from 'ng-inline-svg';
import { WebSocketProvider } from '../providers/web-socket/web-socket';
import { LocationProvider } from '../providers/location/location';
import { EventInfoProvider } from '../providers/event-info/event-info';
import { Ng2ImgToolsModule } from 'ng2-img-tools';
import { Ng2FileInputModule } from 'ng2-file-input';
import { AgendaProvider } from '../providers/agenda/agenda';
import { VotingProvider } from '../providers/voting/voting';
import { PrizeGameProvider } from '../providers/prize-game/prize-game';
import { GeoFenceProvider } from '../providers/geo-fence/geo-fence';
import { WebPushProvider } from '../providers/web-push/web-push';
import { HtttpInterceptorProvider } from '../providers/htttp-interceptor/htttp-interceptor';
import { AuthenticationProvider } from '../providers/authentication/authentication';
import { StorageWraperProvider } from '../providers/storage-wraper/storage-wraper';
import { TokenHelperProvider } from '../providers/token-helper/token-helper';
import { HttpErrorInterceptorProvider } from '../providers/http-error-interceptor/http-error-interceptor';
import { IntervalServiceProvider } from '../providers/interval-service/interval-service';
import { EventNavigationProvider } from '../providers/event-navigation/event-navigation';
import { MetricPipe } from '../pipes/metric/metric';
import {LinkedIn} from "@ionic-native/linkedin";
import {Facebook} from "@ionic-native/facebook";
import { FcmProvider } from '../providers/fcm/fcm';
import {ContactRequestPage} from "../pages/contact-request/contact-request";
import {ContactRequest} from "../models/user.model";
import {ContactRequestPageModule} from "../pages/contact-request/contact-request.module";
import {MessagePage} from "../pages/message/message";
import {MessagePageModule} from "../pages/message/message.module";
import {MessengerPageModule} from "../pages/messenger/messenger.module";
import {MessengerPage} from "../pages/messenger/messenger";
import { InAppBrowserProvider } from '../providers/in-app-browser/in-app-browser';
import { Diagnostic } from '@ionic-native/diagnostic';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';
import { DocumentsProvider } from '../providers/documents/documents';
import { FileTransfer } from '@ionic-native/file-transfer';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { ImageResizer } from '@ionic-native/image-resizer';
import { ExhibitorApiService } from '../providers/exhibitors.provider';
import {Deeplinks} from "@ionic-native/deeplinks";
import {RedirectPage} from "../pages/redirect/redirect";
import {RedirectPageModule} from "../pages/redirect/redirect.module";
import { FileChooser } from '@ionic-native/file-chooser';
import { File } from '@ionic-native/file';
import { Base64 } from '@ionic-native/base64';
import { TruncateModule } from 'ng2-truncate';
import { FileOpener } from '@ionic-native/file-opener';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { ImageCropperModule } from 'ngx-img-cropper';
import { EventTicketProvider } from '../providers/event-ticket/event-ticket';
import { NgxQRCodeModule } from 'ngx-qrcode3';
import { QRScanner } from '@ionic-native/qr-scanner';
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { ServiceWorkerModule } from '@angular/service-worker';
import * as firebase from 'firebase';
import { AngularFireModule } from 'angularfire2';



// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideSettings(storage: Storage) {
  /**
   * The Settings provider takes a set of default settings for your app.
   *
   * You can add new settings options at any time. Once the settings are saved,
   * these values will not overwrite the saved values (this can be done manually if desired).
   */
  return new Settings(storage, {
    option1: true,
    option2: 'Ionitron J. Framework',
    option3: '3',
    option4: 'Hello',
  });
}

const firebaseConfig = {
  apiKey: "AIzaSyAApBBqJd0VIc3g0Z_6jvSAHbszQI-M1Ck",
  authDomain: "matchabout-e39a6.firebaseapp.com",
  databaseURL: "https://matchabout-e39a6.firebaseio.com",
  projectId: "matchabout-e39a6",
  storageBucket: "matchabout-e39a6.appspot.com",
  messagingSenderId: "70810195268",
  appId: "1:70810195268:web:86609d50f99a54eb583311",
  measurementId: "G-C046YVGT13"
};

@NgModule({
  declarations: [MyApp],
  imports: [
    Ng2ImgToolsModule,
    Ng2FileInputModule.forRoot(),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CustomFormsModule,
    PasswordStrengthBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    IonicModule.forRoot(MyApp, {
      mode: 'md',
      //locationStrategy: 'path'
    }),

    IonicStorageModule.forRoot(),
    LinkyModule,
    InlineSVGModule,
    BrowserAnimationsModule,
    ContactRequestPageModule,
    MessengerPageModule,
    RedirectPageModule,
    TruncateModule,
    NgxQRCodeModule,
    // InlineSVGModule.forRoot({ baseUrl: 'https://192.168.0.150/matchabout2/' }),
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  exports: [
    CustomFormsModule,
    PasswordStrengthBarModule,

    LinkyModule,
    InlineSVGModule,
    Ng2FileInputModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp, ContactRequestPage, MessengerPage, RedirectPage],
  providers: [
    Api,
    Items,
    User,
    Camera,
    LinkedIn,
    Facebook,
    SplashScreen,
    Geolocation,
    StatusBar,
    InAppBrowser,
    DatePipe,
    MetricPipe,
    { provide: Settings, useFactory: provideSettings, deps: [Storage] },
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    MyEventsProvider,
    MessengerProvider,
    MatchmakingProvider,
    CurrentEventProvider,
    ProfileProvider,
    GlobalNotificationsProvider,
    ProfileSettingsProvider,
    ContactRequestProvider,
    EventWallProvider,
    EventWallProvider,
    CountryListProvider,
    WebSocketProvider,
    LocationProvider,
    EventInfoProvider,
    AgendaProvider,
    VotingProvider,
    PrizeGameProvider,
    GeoFenceProvider,
    WebPushProvider,
    FcmProvider,
    InAppBrowserProvider,
    Diagnostic,
    OpenNativeSettings,
    HtttpInterceptorProvider,
    DocumentsProvider,
    File,
    FileTransfer,
    FirebaseX,
    FileChooser,
    FileOpener,
    Base64,
    ImageResizer,
    DocumentViewer,
    LocationAccuracy,
    Deeplinks,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HtttpInterceptorProvider,
      multi: true,
    },
    AuthenticationProvider,
    StorageWraperProvider,
    TokenHelperProvider,
    HttpErrorInterceptorProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorProvider,
      multi: true,
    },
    IntervalServiceProvider,
    EventNavigationProvider,
    InAppBrowserProvider,
    ExhibitorApiService,
    AnalyticsProvider,
    EventTicketProvider,
    QRScanner,
    WebPushNotificationsService
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts